import { render, staticRenderFns } from "./form.vue?vue&type=template&id=13761c3e&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/home/nvpa/nvpa-corporate/nuxt/components/general/Breadcrumbs.vue').default,InschrijvingNavigation: require('/home/nvpa/nvpa-corporate/nuxt/components/inschrijving/navigation.vue').default})
